import { createIcon, type IconProps } from '@chakra-ui/react'

const IconHeartOutline = createIcon({
  displayName: 'IconHeartOutline',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
    />
  )
})

const IconHeartFilled = createIcon({
  displayName: 'IconHeartFilled',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
    />
  )
})

interface IconHeartProps extends IconProps {
  filled?: boolean
}

export default function IconHeart({ filled = false, ...props }: IconHeartProps) {
  return filled ? <IconHeartFilled {...props} /> : <IconHeartOutline {...props} />
}
